import { render, staticRenderFns } from "./exhibitionInfo2.vue?vue&type=template&id=56284a28&scoped=true&"
import script from "./exhibitionInfo2.vue?vue&type=script&lang=js&"
export * from "./exhibitionInfo2.vue?vue&type=script&lang=js&"
import style0 from "./exhibitionInfo2.vue?vue&type=style&index=0&id=56284a28&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56284a28",
  null
  
)

export default component.exports